import { type LayoutPages } from '../../types';
import HostedDesktopInitPage from './DesktopInitPage';
import HostedDesktopWaitingPage from './DesktopWaitingPage';
import HostedDesktopAgentStartPage from './DesktopAgentStartPage';
import HostedDesktopAppPairingPage from './DesktopAppPairingPage';
import HostedDesktopDonePage from './DesktopDonePage';
import HostedDesktopAbortPage from './DesktopAbortPage';
import HostedDesktopAppPickerPage from './DesktopAppPickerPage';
import HostedDesktopAppInstallPage from './DesktopAppInstallPage';
import HostedPassthroughShell from '../../../layouts/PassthroughShell';

export const hostedDesktopPages: LayoutPages = {
  Shell: HostedPassthroughShell,
  Loading: HostedDesktopInitPage,
  Init: HostedDesktopInitPage,
  Auth: HostedDesktopInitPage,
  WaitingForPresentation: HostedDesktopWaitingPage,
  AgentStart: HostedDesktopAgentStartPage,
  AppPairing: HostedDesktopAppPairingPage,
  Done: HostedDesktopDonePage,
  Abort: HostedDesktopAbortPage,
  AppPicker: HostedDesktopAppPickerPage,
  AppInstall: HostedDesktopAppInstallPage,
};

export { default as HostedDesktopAppPickerPage } from './DesktopAppPickerPage';
export { default as HostedDesktopAppInstallPage } from './DesktopAppInstallPage';
